export const stripOutsideSlashes = (url: string): string =>
  url
    .replace(/^\//, '') // strip leading slash
    .replace(/\/$/, ''); // strip trailing slash

/**
 * Adds leading/trailing slashes where applicable
 */
export const normaliseUrl = (url: string): string => {
  if (!url || url === '/') {
    return '/';
  }
  const bareUrl = stripOutsideSlashes(url);
  const isAbsoluteUrl =
    bareUrl.startsWith('http://') || bareUrl.startsWith('https://');
  const hasQueryString = bareUrl.includes('?');

  if (hasQueryString) {
    // no trailing slash for query string
    return isAbsoluteUrl ? bareUrl : `/${bareUrl}`;
  }

  return isAbsoluteUrl ? `${bareUrl}/` : `/${bareUrl}/`;
};
